import classNames from 'classnames';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import SharedAsset from '#client/components/SharedAsset';

import { CardTitle } from './cardTitle';
import { useStyles } from './useStyles';

export const CardHeader = ({
  imageUrl, user, title, className
}) => {
  const classes = useStyles();

  return (
    <Box className={classNames(classes.headerBox, className)}>
      <SharedAsset
        className={classes.headerImage}
        src={imageUrl}
        alt="card-image"
        width={480}
      />
      <CardTitle user={user} title={title} />
    </Box>
  );
};

CardHeader.propTypes = {
  imageUrl: PropTypes.string,
  user: PropTypes.string,
  title: PropTypes.string
};

CardHeader.defaultProps = {
  imageUrl: '',
  user: 'User',
  title: 'Title'
};
